module.exports = __webpack_public_path__ + "img/pricing_background.3cf23372.jpg";